import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field, change } from 'redux-form';
import { Grid } from './../../../assets/theme/layout';
import { Page, Wrapper, Paper, Content, Loading, Button, Toolbar, ButtonsGroup } from './../../../components/ui';
import { InputTextField, SelectField, OptionField } from './../../../components/ui/input';
import { TreatmentGroupService } from './../../../services';
import { findPermissionProps } from './../../../utilities/utils';

import API from './../../../config/api';
import TEXT from './../../../config/text';

const validate = values => {
  const errors = {};

  if (!values.name) {
    errors.name = TEXT.validation.required;
  } else if (values.name.length > 255) {
    errors.name = TEXT.validation.maxlength(255);
  }

  return errors;
}

class Page__TreatmentGroupForm extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        permission: null,
        name: '...',
        title: '...',
        loading: true,
        submited: false,
        id: null,
        entity: null
      };
    }

    componentDidMount(){
      this._Init();
    }

    _Init = () => {
      this.setState({ permission: findPermissionProps(this.props.session, API.permissions.treatment_groups, this.props.t('page.treatment_groups.name')) });

      const id = this.props.match.params.id;
      if(id){
        this._Find(id);
      }else{
        this.setState({ loading: false, title: this.props.t('text.new_entry') });
      }
    };

    _Save = (values) => {
      this.setState({ loading: true, submited: true });

      TreatmentGroupService.save(values).then(() => {
        this.props.alertShow({ open: true, severity: 'success', message: TEXT.message.success });
        this.props.history.push('/treatment-groups');
      }).catch((error) => {
        this.setState({ loading: false, submited: false });
        this.props.alertShow({ open: true, severity: 'error', message: error.data ? error.data.message : TEXT.message.error });
      });
    };

    _Update = (id, values) => {
      this.setState({ loading: true, submited: true });

      TreatmentGroupService.update(id, values).then(() => {
        this.props.alertShow({ open: true, severity: 'success', message: TEXT.message.success });
        this.props.history.push('/treatment-groups');
      }).catch((error) => {
        this.setState({ loading: false, submited: false });
        this.props.alertShow({ open: true, severity: 'error', message: error.data ? error.data.message : TEXT.message.error });
      });
    };

    _Find = (id) => {
      TreatmentGroupService.find(id).then((response) => {
        const form = this.props.form;

        this.setState({
          loading: false,
          id: response.treatmentGroup._id,
          entity: response.treatmentGroup,
          title: response.treatmentGroup.name
        });

        this.props.dispatch(change(form, 'name', response.treatmentGroup.name));
        this.props.dispatch(change(form, 'enabled', response.treatmentGroup.enabled));
      }).catch(() => {
        this.props.alertShow({ open: true, severity: 'error', message: TEXT.message.error });
      });
    };

    handleSubmitForm = (values) => {
      if (this.state.id) {
        this._Update(this.state.id, values);
      } else {
        this._Save(values);
      }
    };

    render(){
      const { handleSubmit, invalid, t } = this.props;
      const { permission, name, loading, title, submited } = this.state;

      return(
        <Page>
          <Wrapper>
            <Toolbar title={permission ? permission.name : name} dividerMobile>
              <Button component={ NavLink } to="/treatment-groups" icon="back" color="primary" size="medium">
                {t('button.back')}
              </Button>
            </Toolbar>

            <Paper disablePadding>
              <Toolbar title={ title } size="medium" variant="divider" disableMargin />

              <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
                <Content divider disableMargin>
                  { (submited || loading) && (<Loading variant="absolute"/>) }

                  <Content marginBottom>
                    <Toolbar title={t('text.general')} size="small" />
                    <Grid container spacing={3}>
                      <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                        <Field name="name" component={ InputTextField } label={t('field.name')} type="text" required />
                      </Grid>
                      <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
                        <Field name="enabled" component={ SelectField } label={t('field.status')}>
                          <OptionField value="true">{t('field.option_field.active')}</OptionField>
                          <OptionField value="false">{t('field.option_field.disabled')}</OptionField>
                        </Field>
                      </Grid>
                    </Grid>
                  </Content>
                </Content>

                <Content>
                  <ButtonsGroup align="right">
                    <Button component={ NavLink } to="/treatment-groups" color="danger" size="medium" icon="cancel">
                      {t('button.cancel')}
                    </Button>
                    <Button type="submit" size="medium" icon="add" color="success" disabled={ invalid || submited }>
                      {t('button.save')}
                    </Button>
                  </ButtonsGroup>
                </Content>
              </form>
            </Paper>
          </Wrapper>
        </Page>
      )
    }

};

Page__TreatmentGroupForm = reduxForm({
  form: 'Page__TreatmentGroupForm',
  validate,
  initialValues: {
    enabled: 'true'
  }
})(Page__TreatmentGroupForm);

const mapStateToProps = (state) => {
  return { session: state.userState }
};

const mapDispatchToProps = (dispatch) => {
  return {
    alertShow: (data) => {
      dispatch({ type: 'ALERT_SHOW', data: data });
    }
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Page__TreatmentGroupForm));
